<template>
  <div>
    <div class="page-header page-header-small clear-filter">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg1.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <h1 class="h1-seo">Sustainability</h1>
        </div>
    </div>

    <section id="company" class="section">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h5 class="text-primary font-weight-bold">
              Date of  last update: October 16, 2023
            </h5>
            <p>
              Since the Sustainable Finance Disclosure Regulation came into effect, provide financial market participants such as Alpha Based Capital insight into how it manages sustainability into its investment decisions. 
            </p>
            <h4>
              Sustainability Risks 
            </h4>
            <p>
              Investments may be exposed to Sustainability Risks. Examples of such events or circumstances include climate change, involvement in child labor, or scarcity of raw materials. Such events and circumstances could have a negative effect on the value of investments. 
            </p>
            <p>
              Alpha Based Capital assesses Sustainability Risks as any other risks such as market risk. All of these risks could result in the possibility that expected or targeted returns may not be achieved. 
            </p>
            <p>
              By integrating risk factors – including sustainability factors - into the investment decision process Sustainability Risks are managed by Alpha Based Capital. If Alpha Based Capital identifies high risks - including sustainability risks - Alpha Based Capital will not invest or replaces an existing investment 
            </p>
            <h4>No Consideration of Principal Adverse Impacts </h4>
            <p>
              Alpha Based Capital does not consider principal adverse impacts of its investments decisions on sustainability factors at entity level. As the Fund Manager is required to assess all indicators of Table 1 of Delegated Regulation 2022/1288 as well as the relevant indicators of Tables 2 and 3 if it were to include negative impacts on sustainability factors at entity level the Fund Manager believes that there is currently insufficient reliable data available to adequately analyze all of these negative impacts and integrate them into its investment process.
            </p>
            <p>
              Alpha Based Capital takes into account some principal adverse impacts on sustainability factors for GSELS SQE.
            </p>
            <p>
              Alpha Based Capital will follow developments in this area closely and reconsider the above statement if it appears that sufficient reliable data becomes available in the market.
            </p>
            <h4>
              Remuneration and sustainability risks 
            </h4>
            <p>
              Alpha based Capital’s remuneration policy is aimed at retaining  qualified staff, to reward ethical behaviour, to manage risks - including sustainability risks- , sound management of its funds and treating its investors fairly. No variable payments are awarded. 
            </p>

          </div>
        </div>
        </div>
      </section>
      <!-- <section id="team" class="section section-team text-center">
      <div class="container">
                <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
        <div class="team">
          <div class="row justify-content-md-center">
            <div class="col-sm-6 col-md-4" v-for="person in team" :key="person.name">
              <div class="team-player">
                <img
                  :src="'img/' + person.img"
                  alt="Thumbnail Image"
                  height="250px"
                  class="img-raised"
                />
                <h5 class="title">{{person.name}}</h5>
                <p class="category pt-3 pb-0 mb-0">{{person.title}}</p>
                <p class="category">{{person.desc}}</p>
              </div>
            </div>
          </div>
          </div></div>
        </div>
      </div>
    </section> -->
    </div>
</template>
<script>
import { Parallax } from '@/components';

export default {
  name: 'index',
  bodyClass: 'index-page',
  data() {
    return {
      // team: [
      //   {
      //     img: 'joost-bouman.jpg',
      //     name: 'Joost Bouman',
      //     title: 'Managing Director',
      //     desc: 'General Manager'
      //   },
      //   {
      //     img: 'henry-van-ginkel.jpg',
      //     name: 'Henry van Ginkel',
      //     title: 'Managing Director',
      //     desc: 'Portfolio Manager'
      //   },
      //   {
      //     img: 'philip-van-wijngaarden.png',
      //     name: 'Philip van Wijngaarden',
      //     title: 'Managing Director',
      //     desc: 'Risk Manager'
      //   },
      //   {
      //     img: 'adri-verboven.png',
      //     name: 'Adri Verboven',
      //     title: 'Risk Advisor'
      //   },
      //   {
      //     img: 'patrick-lageweg.png',
      //     name: 'Patrick Lageweg',
      //     title: 'Compliance Officer'
      //   },
      // ],
    }
  },
  components: {
    Parallax
  }
};
</script>
<style></style>
